<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns" :key="column">{{ column }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <td v-for="column in columns" :key="column">
          <template v-if="hasValue(item, column)">
            {{ itemValue(item, column) }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "l-table",
  props: {
    columns: Array,
    data: Array,
  },
  methods: {
    hasValue(item, column) {
      if ((item, column)) {
        return item[column.toLowerCase()] !== "undefined";
      }
    },
    itemValue(item, column) {
      if ((item, column)) {
        return item[column.toLowerCase()];
      }
    },
  },
};
</script>
<style></style>
